module.exports = __webpack_public_path__ + "img/logo-agv.269e6834.png";